/* global angular */

import * as R from 'ramda';

export default function VendorController(
  $q,
  $scope,
  $rootScope,
  alerts,
  confirmDialog,
  editVendorDialog,
  editProductDialog,
  loaderService,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  vmDataService,
  vmSharedModelService,
  reportsDataService
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.loaderService = loaderService;
  vm.filters = vmSharedModelService.filters;

  vm.handleExpandVendor = _handleExpandVendor;
  vm.handleAddProduct = _handleAddProduct;
  vm.handleEditVendor = _handleEditVendor;
  vm.handleRunDetailReport = _handleRunDetailReport;
  vm.handleDeleteVendor = _handleDeleteVendor;

  vm.notificationCount = _notificationCount;

  _activate();

  /**
   * Vendor object definition
   * @typedef {Object} vendor
   * @property {int} alertCount
   * @property {int} remindCount
   */

  /** ******************************************************
   * Event Handlers
   */

  function _handleExpandVendor() {
    if (vm.vendor.hasProducts) {
      vm.vendor.isExpanded = !vm.vendor.isExpanded;
    }
  }

  function _handleAddProduct($event) {
    _showEditProductDialog($event, {
      masterVendorId: vm.vendor.masterVendorId,
      product: {
        vendorId: vm.vendor.vendorId,
        productId: -1,
        financialAmount: 0.00,
      },
      vendor: vm.vendor,
      addCallback: _handleAddedProduct,
    });
  }

  function _handleAddedProduct(product) {
    vm.vendor.products.push(product);
    vm.vendor.hasProducts = true;
    vm.vendor.products = R.sortBy(
      R.prop('name'),
      vm.vendor.products
    );
  }

  function _handleEditVendor($event) {
    loaderService.showViewLoader = true;
    // Fetch the detailed vendor model instead of the abbreviated one that comes from getVendors
    return vmSharedModelService.getVendor(vm.vendor.vendorId, true).then((vendor) => {
      loaderService.showViewLoader = false;
      angular.extend(vm.vendor, vendor);
      return _showEditVendorDialog($event, {
        vendor: vm.vendor,
        addCallback: null,
      });
    });
  }

  function _handleRunDetailReport() {
    loaderService.showViewLoader = true;
    return vmDataService.getVendorDetailReport()
      .then((reportData) => {
        const reportId = reportData.data.reportId;
        const parameters = [];
        parameters.push({
          ParameterName: 'VendorID',
          ParameterValue: vm.vendor.vendorId.toString(),
        });
        reportsDataService.generateAppReport(1, reportId, 'PDF', parameters, false)
          .then((response) => {
            reportsDataService.download(response);
            loaderService.showViewLoader = false;
            $scope.$broadcast('runVendorManagementReport', reportData);
          });
      });
  }

  function _handleDeleteVendor($event) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteVendorDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Vendor?',
        message: `Deleting vendor might sever its existing association within BCP Blueprint,
        Enterprise modeling or Audit trail. Are you sure you want to delete the vendor "${vm.vendor.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteVendorDialog);
  }

  function _handleCancelDelete() {
    _closeDeleteVendorDialog();
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return vmSharedModelService.deleteVendor(vm.vendor.vendorId)
      .then(() => {
        alerts.success(`The Vendor "${vm.vendor.name}" has successfully been deleted.`);
        $rootScope.$broadcast('reloadVMData');
        $rootScope.$broadcast('refreshNotifications');
        _closeDeleteVendorDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the vendor.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** ******************************************************
   * Event Handlers
   */

  function _activate() {
    _initNotificationFlag();
    loaderService.showViewLoader = false;
    vm.appIsLoaded = true;
  }

  function _initNotificationFlag() {
    const { alertCount, remindCount } = vm.vendor;

    // vm.vendor.notificationCount = alertCount + remindCount;
    if (alertCount > 0) {
      vm.vendor.notificationFlagHoverText = `There ${alertCount === 1 ? 'is' : 'are'} ${alertCount} past due ${
        pl('task', alertCount)} ${remindCount === 1 ? '' : `and ${remindCount} upcoming ${
        pl('task', remindCount)}`}that require${alertCount === 1 && remindCount === 0 ? '' : 's'} attention`;
    } else {
      vm.vendor.notificationFlagHoverText = `There ${remindCount === 1 ? 'is' : 'are'} ${remindCount} upcoming ${
        pl('task', remindCount)} that ${pl('require', remindCount)} attention`;
    }
  }

  function _showEditProductDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editProductDialog = ssDialogService.alert(
      editProductDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editProductDialog);
  }

  function _showEditVendorDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editVendorDialog = ssDialogService.alert(
      editVendorDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editVendorDialog);
  }

  function _closeDeleteVendorDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteVendorDialog);
  }

  function _notificationCount() {
    return vm.vendor.alertCount + vm.vendor.remindCount;
  }

  /**
   * Pluralizes a common noun
   * @param {string} noun - the common noun to pluralize
   * @param {int} count - the number to determine pluralization
   * @return {string} - the pluralized word
   */
  function pl(noun, count) {
    return count === 1 ? noun : `${noun}s`;
  }
}

VendorController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'confirmDialog',
  'editVendorDialog',
  'editProductDialog',
  'loaderService',
  'ssDialogService',
  'theSafeSharedModelService',
  'userService',
  'vmDataService',
  'vmSharedModelService',
  'reportsDataService',
];
